type Status = 'healthy' | 'unhealthy' | 'unknown';

export default function StatusBadge({ status }: { status: Status }) {
  const cfg = {
    healthy:   { dot: 'bg-green-400', text: 'text-green-400', label: 'Operational' },
    unhealthy: { dot: 'bg-red-400',   text: 'text-red-400',   label: 'Degraded'    },
    unknown:   { dot: 'bg-gray-500',  text: 'text-gray-400',  label: 'Unknown'     },
  }[status];

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${cfg.text}`}>
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
